(function () {
  'use strict';

  var reducedMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function initMobileNav() {
    var burger = document.querySelector('[data-rexulo-burger]');
    var panel = document.getElementById('rexulo-mobile-nav');
    if (!burger || !panel) return;

    burger.addEventListener('click', function () {
      var expanded = burger.getAttribute('aria-expanded') === 'true';
      burger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      if (expanded) {
        panel.setAttribute('hidden', '');
      } else {
        panel.removeAttribute('hidden');
      }
    });
  }

  function initStickyNav() {
    var nav = document.querySelector('[data-rexulo-nav]');
    if (!nav || !('IntersectionObserver' in window)) return;
    var sentinel = document.createElement('div');
    sentinel.setAttribute('aria-hidden', 'true');
    sentinel.style.position = 'absolute';
    sentinel.style.top = '0';
    sentinel.style.height = '1px';
    sentinel.style.width = '1px';
    nav.parentNode.insertBefore(sentinel, nav);

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          nav.classList.toggle('is-stuck', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    observer.observe(sentinel);
  }

  function initHero() {
    var roots = document.querySelectorAll('[data-rexulo-hero]');
    if (!roots.length) return;

    Array.prototype.forEach.call(roots, function (root) {
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-rexulo-slide]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-rexulo-dot]'));
      var prev = root.querySelector('[data-rexulo-prev]');
      var next = root.querySelector('[data-rexulo-next]');
      if (slides.length < 2) return;

      var fills = dots.map(function (dot) {
        return dot.querySelector('[data-rexulo-dot-fill]');
      });

      var index = 0;
      var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
      var autoplayEnabled = root.getAttribute('data-autoplay') === 'true' && !reducedMotion;
      var progress = 0;
      var lastTs = 0;
      var paused = false;
      var rafId = null;

      function paint() {
        for (var i = 0; i < fills.length; i++) {
          if (!fills[i]) continue;
          if (i !== index) {
            fills[i].style.width = '0%';
          } else {
            fills[i].style.width = autoplayEnabled ? Math.min(100, (progress / interval) * 100) + '%' : '100%';
          }
        }
      }

      function show(nextIndex) {
        index = (nextIndex + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          var active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach(function (dot, i) {
          var active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
        progress = 0;
        lastTs = 0;
        paint();
      }

      function loop(ts) {
        if (!lastTs) lastTs = ts;
        var delta = ts - lastTs;
        lastTs = ts;

        if (!paused && autoplayEnabled) {
          progress += delta;
          if (progress >= interval) {
            show(index + 1);
          } else {
            paint();
          }
        }
        rafId = window.requestAnimationFrame(loop);
      }

      function start() {
        if (!autoplayEnabled || rafId) return;
        lastTs = 0;
        rafId = window.requestAnimationFrame(loop);
      }

      function pause() {
        paused = true;
      }

      function resume() {
        paused = false;
        lastTs = 0;
      }

      if (prev) {
        prev.addEventListener('click', function () {
          show(index - 1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          show(index + 1);
        });
      }
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          show(i);
        });
      });

      root.addEventListener('mouseenter', pause);
      root.addEventListener('mouseleave', resume);
      root.addEventListener('focusin', pause);
      root.addEventListener('focusout', function (event) {
        if (!root.contains(event.relatedTarget)) resume();
      });
      root.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') {
          show(index + 1);
        } else if (event.key === 'ArrowLeft') {
          show(index - 1);
        }
      });

      show(0);
      start();
    });
  }

  function initPartFinder() {
    var toggles = document.querySelectorAll('[data-rx-finder-toggle]');
    Array.prototype.forEach.call(toggles, function (toggle) {
      var panelId = toggle.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : null;
      if (!panel) return;

      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (expanded) {
          panel.setAttribute('hidden', '');
        } else {
          panel.removeAttribute('hidden');
        }
      });
    });

    var forms = document.querySelectorAll('[data-rx-finder-panel]');
    Array.prototype.forEach.call(forms, function (form) {
      var typeSelect = form.querySelector('[data-rx-finder-type]');
      var brandSelect = form.querySelector('[data-rx-finder-brand]');
      var modelSelect = form.querySelector('[data-rx-finder-model]');
      if (!brandSelect || !modelSelect) return;

      function filterBrands() {
        var type = typeSelect && typeSelect.value ? typeSelect.value : '';
        Array.prototype.forEach.call(brandSelect.options, function (option) {
          if (!option.value) return;
          var optionType = option.getAttribute('data-type') || '';
          var types = optionType
            .split(',')
            .map(function (item) {
              return item.trim();
            })
            .filter(Boolean);
          var visible = !type || types.length === 0 || types.indexOf(type) !== -1;
          option.hidden = !visible;
          option.disabled = !visible;
        });
        if (brandSelect.selectedOptions.length && brandSelect.selectedOptions[0].disabled) {
          brandSelect.value = '';
        }
      }

      function filterModels() {
        var brand = brandSelect.value;
        Array.prototype.forEach.call(modelSelect.options, function (option) {
          if (!option.value) return;
          var optionBrand = option.getAttribute('data-brand') || '';
          var visible = !brand || optionBrand === brand;
          option.hidden = !visible;
          option.disabled = !visible;
        });
        if (modelSelect.selectedOptions.length && modelSelect.selectedOptions[0].disabled) {
          modelSelect.value = '';
        }
      }

      if (typeSelect) {
        typeSelect.addEventListener('change', function () {
          filterBrands();
          filterModels();
        });
      }
      brandSelect.addEventListener('change', filterModels);
    });
  }

  function initInquiryDialog() {
    var dialog = document.getElementById('rexulo-inquiry-dialog');
    if (!dialog) return;

    var openers = document.querySelectorAll('[data-rexulo-open-inquiry]');
    var closer = dialog.querySelector('[data-rexulo-close-inquiry]');
    var lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      var firstField = dialog.querySelector('input, textarea, button');
      if (firstField && typeof firstField.focus === 'function') firstField.focus();
    }

    function close() {
      if (typeof dialog.close === 'function') {
        if (dialog.open) dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    Array.prototype.forEach.call(openers, function (opener) {
      opener.addEventListener('click', function (event) {
        event.preventDefault();
        open();
      });
    });

    if (closer) {
      closer.addEventListener('click', function (event) {
        event.preventDefault();
        close();
      });
    }

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) close();
    });

    if (dialog.querySelector('[data-rexulo-posted="true"]')) {
      open();
    }
  }

  function initRouteClass() {
    if (document.querySelector('[id*="cart-section"]')) {
      document.body.classList.add('rx-cart-page');
    }
  }

  function initCollectionCards() {
    if (!document.body.classList.contains('rx-collection')) return;

    // The native card renders the product name twice (an h3 plus a text link).
    // Keep the h3 as the single visible title and drop the duplicate node.
    var duplicates = document.querySelectorAll('.product-card__content > a.contents');
    Array.prototype.forEach.call(duplicates, function (node) {
      node.parentNode.removeChild(node);
    });

    var titles = document.querySelectorAll('.product-card__content > h3');
    Array.prototype.forEach.call(titles, function (title) {
      var prev = title.previousElementSibling;
      if (prev && prev.classList.contains('rx-card-kicker')) return;
      var kicker = document.createElement('span');
      kicker.className = 'rx-card-kicker';
      kicker.textContent = 'REXULO GENUINE';
      title.parentNode.insertBefore(kicker, title);
    });
  }

  function initCartDrawer() {
    var link = document.querySelector('[data-rexulo-cart]');
    var drawer = document.querySelector('theme-drawer#cart-drawer');
    if (!link) return;

    var sync = function () {
      link.setAttribute('aria-expanded', drawer && drawer.hasAttribute('open') ? 'true' : 'false');
    };
    if (drawer && window.MutationObserver) {
      new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['open'] });
    }
    sync();

    link.addEventListener('click', function (event) {
      if (event.defaultPrevented) return;
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var el = drawer || document.querySelector('theme-drawer#cart-drawer');
      if (!el || typeof el.open !== 'function') return;
      var actions = window.Shopify && window.Shopify.actions;
      event.preventDefault();
      try {
        if (actions && typeof actions.openCart === 'function') {
          actions.openCart();
        } else {
          el.open();
        }
      } catch (err) {
        window.location.href = link.href;
      }
    });

    // Horizon renders a non-modal drawer without a backdrop element, so treat a
    // click outside the panel as "backdrop" and close through the drawer API.
    document.addEventListener('click', function (event) {
      var el = drawer || document.querySelector('theme-drawer#cart-drawer');
      if (!el || !el.hasAttribute('open')) return;
      if (link.contains(event.target)) return;
      if (el.contains(event.target)) return;
      if (typeof el.close === 'function') el.close();
    });
  }
  function init() {
    initCartDrawer();
    initRouteClass();
    initCollectionCards();
    initMobileNav();
    initStickyNav();
    initHero();
    initPartFinder();
    initInquiryDialog();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
